(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["alma-bought-badge"] && !Shopify.designMode) return;
  try {
    
    if (!customElements.get('alma-bought-badge-component')) {
      customElements.define('alma-bought-badge-component', class extends HTMLElement {
        connectedCallback() {
          this.frame = requestAnimationFrame(() => {
            this.badge = this.querySelector('template').content.firstElementChild.cloneNode(true);
            this.sync = () => {
              this.frame = 0;
              const details = document.querySelector('main .product-details');
              const title = details?.querySelector('h1');
              if (!title) return;
              const anchor = title.closest('.text-block') || title;
              const price = anchor.parentElement.querySelector('product-price');
              if (price) {
                if (price.previousElementSibling !== this.badge) price.before(this.badge);
              } else if (anchor.nextElementSibling !== this.badge) {
                anchor.after(this.badge);
              }
            };
            this.observer = new MutationObserver(() => {
              if (!this.frame) this.frame = requestAnimationFrame(this.sync);
            });
            this.observer.observe(document.querySelector('main') || document.body, { childList: true, subtree: true });
            this.sync();
          });
        }
        disconnectedCallback() {
          cancelAnimationFrame(this.frame);
          this.observer?.disconnect();
          this.badge?.remove();
        }
      });
    }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["clothzz-brand-header"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('clothzz-gift-header')) {
  customElements.define('clothzz-gift-header', class extends HTMLElement {
    connectedCallback() {
      if (this.abort) return;
      this.abort = new AbortController();
      const signal = this.abort.signal;
      const on = (element, event, handler) => element.addEventListener(event, handler, {signal});
      this.config = JSON.parse(this.querySelector('[data-header-config]').textContent);
      this.dialog = this.querySelector('[data-menu-dialog]');
      this.menuButton = this.querySelector('[data-open-menu]');
      this.searchInput = this.querySelector('[data-search-input]');
      this.searchResults = this.querySelector('[data-search-results]');
      this.request = 0;
      on(this.menuButton, 'click', () => {
        this.resetMenu();
        this.closeSearch();
        this.dialog.showModal();
        this.menuButton.setAttribute('aria-expanded', 'true');
      });
      on(this.querySelector('[data-close-menu]'), 'click', () => this.dialog.close());
      on(this.dialog, 'click', event => {
        if (event.target !== this.dialog) return;
        const rect = this.dialog.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) this.dialog.close();
      });
      on(this.dialog, 'close', () => {
        this.menuButton.setAttribute('aria-expanded', 'false');
        this.menuButton.focus();
      });
      on(this.querySelector('[data-back-menu]'), 'click', () => { this.resetMenu(); this.activeMenuCard?.focus(); });
      this.querySelectorAll('[data-panel]').forEach(button => on(button, 'click', () => {
        this.activeMenuCard = button;
        button.setAttribute('aria-expanded', 'true');
        this.querySelectorAll('.ch-mobile-accordion').forEach(accordion => { accordion.open = false; });
        this.querySelector('[data-menu-main]').hidden = true;
        this.querySelectorAll('[data-mobile-panel]').forEach(panel => { panel.hidden = panel.id !== button.dataset.panel; });
        this.querySelector('[data-menu-title]').textContent = button.dataset.title;
        this.querySelector('[data-back-menu]').hidden = false;
        this.querySelector('[data-back-menu]').focus();
        this.dialog.scrollTop = 0;
      }));
      const toggle = this.querySelector('[data-toggle-search]');
      on(toggle, 'click', () => {
        const open = this.toggleAttribute('data-search-open');
        toggle.setAttribute('aria-expanded', String(open));
        if (open) this.searchInput.focus();
        else this.closeSearch();
      });
      this.querySelectorAll('.ch-nav-details').forEach(details => {
        on(details, 'mouseenter', () => {
          if (!matchMedia('(hover: hover) and (min-width: 1024px)').matches) return;
          this.closeMenus(details);
          details.open = true;
        });
        on(details, 'mouseleave', () => { if (!details.contains(document.activeElement)) details.open = false; });
        on(details, 'toggle', () => { if (details.open) this.closeMenus(details); });
      });
      on(document, 'click', event => {
        if (!this.querySelector('.ch-search-wrap').contains(event.target)) this.closeSearch();
        if (!this.querySelector('.ch-navigation').contains(event.target)) this.closeMenus();
      });
      on(this, 'keydown', event => {
        if (event.key === 'Escape') {
          const summary = event.target.closest('.ch-nav-details')?.querySelector('summary');
          this.closeMenus();
          this.closeSearch();
          summary?.focus();
        }
        if (event.key === 'ArrowDown' && event.target === this.searchInput && !this.searchResults.hidden) {
          const first = this.searchResults.querySelector('a');
          if (first) { event.preventDefault(); first.focus(); }
        }
      });
      on(this.searchInput, 'input', () => {
        clearTimeout(this.searchTimer);
        this.searchController?.abort();
        const request = ++this.request;
        const query = this.searchInput.value.trim();
        this.closeSearch();
        if (query.length < 2) return;
        this.searchTimer = setTimeout(() => this.search(query, request), 250);
      });
      on(window, 'resize', () => {
        if (window.innerWidth >= 1024 && this.dialog.open) this.dialog.close();
        this.updateHeight();
      });
      this.observer = new ResizeObserver(() => this.updateHeight());
      this.observer.observe(this);
      const group = document.getElementById('header-group');
      if (group) [...group.children].forEach(child => this.observer.observe(child));
      this.updateHeight();
    }
    disconnectedCallback() {
      this.abort?.abort();
      this.abort = null;
      this.observer?.disconnect();
      this.searchController?.abort();
      clearTimeout(this.searchTimer);
      this.request++;
    }
    updateHeight() {
      document.body.style.setProperty('--header-height', `${Math.round(this.getBoundingClientRect().height)}px`);
      const group = document.getElementById('header-group');
      if (group) {
        const total = [...group.children].reduce((height, child) => height + child.getBoundingClientRect().height, 0);
        document.body.style.setProperty('--header-group-height', `${Math.round(total)}px`);
      }
      document.body.style.setProperty('--transparent-header-offset-boolean', '0');
    }
    resetMenu() {
      this.querySelectorAll('[data-panel]').forEach(button => button.setAttribute('aria-expanded', 'false'));
      this.querySelector('[data-menu-main]').hidden = false;
      this.querySelectorAll('[data-mobile-panel]').forEach(panel => { panel.hidden = true; });
      this.querySelector('[data-menu-title]').textContent = this.config.menu;
      this.querySelector('[data-back-menu]').hidden = true;
    }
    closeMenus(except) {
      this.querySelectorAll('.ch-nav-details[open]').forEach(details => { if (details !== except) details.open = false; });
    }
    closeSearch() {
      this.searchResults.hidden = true;
      this.searchInput.setAttribute('aria-expanded', 'false');
    }
    async search(query, request) {
      const controller = new AbortController();
      this.searchController = controller;
      const timeout = setTimeout(() => controller.abort(), 10000);
      const url = new URL(this.dataset.root.replace(/\/?$/, '/') + 'search/suggest.json', location.origin);
      url.search = new URLSearchParams({q:query, 'resources[type]':'product', 'resources[limit]':'5', 'resources[options][unavailable_products]':'hide'});
      try {
        const response = await fetch(url, {signal:controller.signal});
        if (!response.ok) return;
        const data = await response.json();
        if (request !== this.request || !this.isConnected || document.activeElement !== this.searchInput) return;
        this.searchResults.replaceChildren();
        const products = data.resources?.results?.products || [];
        for (const product of products) {
          const productUrl = new URL(product.url, location.origin);
          if (productUrl.origin !== location.origin) continue;
          const link = document.createElement('a');
          link.className = 'ch-search-result';
          link.href = productUrl.pathname + productUrl.search;
          if (typeof product.image === 'string' && product.image.startsWith('https://')) {
            const image = document.createElement('img');
            image.src = product.image;
            image.width = image.height = 48;
            image.alt = '';
            link.append(image);
          }
          const title = document.createElement('span');
          title.textContent = product.title;
          link.append(title);
          this.searchResults.append(link);
        }
        const all = document.createElement('a');
        const allUrl = new URL(this.config.searchUrl, location.origin);
        allUrl.search = new URLSearchParams({q:query,type:'product'});
        all.href = allUrl.pathname + allUrl.search;
        all.className = 'ch-search-all';
        all.textContent = this.config.allResults;
        this.searchResults.append(all);
        this.searchResults.hidden = false;
        this.searchInput.setAttribute('aria-expanded', 'true');
        this.querySelector('[data-search-status]').textContent = products.length ? `${products.length} ${this.config.searchResults}` : this.config.empty;
      } catch (error) {
        if (error.name !== 'AbortError' && request === this.request) this.closeSearch();
      } finally { clearTimeout(timeout); }
    }
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["clothzz-cart-style"]) return;
  try {
    
(() => {
  const config = () => document.querySelector('[data-cc-config]');
  const read = (key) => config()?.dataset[key] || '';
  const getDeadline = () => {
    const duration = Number(read('minutes')) * 60000;
    let deadline;
    try { deadline = Number(sessionStorage.getItem('clothzz-cart-deadline')); } catch {}
    if (!deadline) {
      deadline = Date.now() + duration;
      try { sessionStorage.setItem('clothzz-cart-deadline', String(deadline)); } catch {}
    }
    return deadline;
  };
  class CartTimer extends HTMLElement {
    connectedCallback() {
      if (read('timer') !== 'true') return;
      this.deadline = getDeadline();
      this.tick();
      this.interval = setInterval(() => this.tick(), 1000);
    }
    disconnectedCallback() { clearInterval(this.interval); }
    tick() {
      const remaining = Math.max(0, Math.ceil((this.deadline - Date.now()) / 1000));
      if (!remaining) {
        if (this.textContent !== read('expired')) { this.textContent = read('expired'); this.dataset.expired = 'true'; }
        return;
      }
      if (!this.querySelector('strong')) {
        this.replaceChildren(document.createTextNode(read('reminder') + ' '), document.createElement('strong'));
      }
      this.querySelector('strong').textContent = `${Math.floor(remaining / 60)}:${String(remaining % 60).padStart(2, '0')}`;
    }
  }
  class CartTrust extends HTMLElement {
    connectedCallback() {
      const template = document.querySelector('#cc-trust-template');
      if (template) this.replaceChildren(template.content.cloneNode(true));
    }
  }
  const labels = () => {
    const copy = document.querySelector('[data-cc-labels]')?.dataset;
    if (copy) {
      document.querySelectorAll('#cart-drawer-heading').forEach(heading => {
        const text = [...heading.childNodes].find(node => node.nodeType === 3 && node.textContent.trim());
        if (text && text.textContent.trim() !== copy.title) text.textContent = copy.title + ' ';
      });
      document.querySelectorAll('.cart__total-label').forEach(label => { if (label.textContent !== copy.subtotal) label.textContent = copy.subtotal; });
    }
    document.querySelectorAll('clothzz-cart-trust').forEach(el => { if (!el.childElementCount) el.connectedCallback(); });
    document.querySelectorAll('.cart__checkout-button').forEach(button => {
      const label = button.querySelector('[data-cc-checkout-label]');
      if (label && label.textContent !== read('checkout')) label.textContent = read('checkout');
    });
  };
  if (!customElements.get('clothzz-cart-timer')) customElements.define('clothzz-cart-timer', CartTimer);
  if (!customElements.get('clothzz-cart-trust')) customElements.define('clothzz-cart-trust', CartTrust);
  labels();
  document.addEventListener('cart:update', event => {
    if (event.detail?.data?.itemCount === 0) { try { sessionStorage.removeItem('clothzz-cart-deadline'); } catch {} }
    requestAnimationFrame(labels);
  });
  let scheduled = false;
  new MutationObserver(() => {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => { scheduled = false; labels(); });
  }).observe(document.body, {childList:true,subtree:true});
  document.addEventListener('shopify:section:load', () => {
    document.querySelectorAll('clothzz-cart-trust').forEach(el => el.connectedCallback());
    document.querySelectorAll('clothzz-cart-timer').forEach(el => {el.disconnectedCallback();el.replaceChildren();delete el.dataset.expired;el.connectedCallback();});
    labels();
  });
  document.addEventListener('click', event => {
    const tee = event.target.closest('.cc-tee-preview button,.cc-tee-preview a');
    if (tee) tee.closest('cart-drawer-component')?.close();
    const button = event.target.closest('[data-cc-preview]');
    if (!button) return;
    if (button.dataset.ccTee) {
      const native = button.parentElement.querySelector('.cc-tee-preview button,.cc-tee-preview a');
      if (native) { native.click(); return; }
    }
    const src = button.dataset.ccPreview;
    let url;
    try { url = new URL(src, location.origin); } catch { return; }
    if (url.protocol !== 'https:') return;
    const dialog = document.querySelector('#cc-preview-dialog');
    const img = dialog.querySelector('img');
    const error = dialog.querySelector('[data-cc-preview-error]');
    error.hidden = true;
    img.hidden = false;
    img.onerror = () => { img.hidden = true; error.hidden = false; };
    img.src = url.href;
    img.alt = button.dataset.title || read('previewTitle');
    dialog.showModal();
  }, true);
  const dialog = document.querySelector('#cc-preview-dialog');
  dialog?.querySelector('button').addEventListener('click', () => dialog.close());
  dialog?.addEventListener('click', event => { if (event.target === dialog) { const r=dialog.getBoundingClientRect();if(event.clientX<r.left||event.clientX>r.right||event.clientY<r.top||event.clientY>r.bottom)dialog.close(); } });
})();

class ClothzzCartDetails extends HTMLElement {
  connectedCallback() {
    this.button = this.querySelector('.cc-details-toggle');
    this.panel = this.querySelector('.cc-details-panel');
    if (!this.button || !this.panel) return;
    this.onclick = event => {
      if (!event.target.closest('.cc-details-toggle')) return;
      const expanded = this.button.getAttribute('aria-expanded') !== 'true';
      this.button.setAttribute('aria-expanded', String(expanded));
      this.toggleAttribute('data-expanded', expanded);
      this.panel.inert = !expanded;
      this.button.querySelector('span').textContent = expanded ? this.dataset.hide : this.dataset.show;
    };
  }
  disconnectedCallback() { this.onclick = null; }
}
if (!customElements.get('clothzz-cart-details')) customElements.define('clothzz-cart-details', ClothzzCartDetails);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["heart-gift"] && !Shopify.designMode) return;
  try {
    

if (!customElements.get('heart-gift-finder')) {
  customElements.define('heart-gift-finder', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.input = this.querySelector('[data-input]');
      this.result = this.querySelector('[data-result]');
      this.loading = this.querySelector('[data-loading]');
      this.empty = this.querySelector('[data-empty]');
      this.error = this.querySelector('[data-error]');
      this.status = this.querySelector('[data-status]');
      this.config = JSON.parse(this.querySelector('[data-config]').textContent);
      this.products = [];
      this.index = 0;
      this.requestId = 0;
      this.formatter = new Intl.NumberFormat(this.dataset.locale || 'en', {style: 'currency', currency: this.dataset.currency || 'USD'});
      this.querySelector('form').addEventListener('submit', event => {
        event.preventDefault();
        this.queueSearch(0);
      });
      this.input.addEventListener('input', () => this.queueSearch(500));
      this.input.addEventListener('compositionend', () => this.queueSearch(500));
      this.querySelectorAll('[data-suggestion]').forEach(button => {
        button.addEventListener('click', () => {
          this.input.value = button.dataset.suggestion;
          this.queueSearch(0);
        });
      });
      this.querySelector('[data-next]').addEventListener('click', () => {
        if (!this.products.length) return;
        this.index = (this.index + 1) % this.products.length;
        this.showProduct();
      });
    }
    disconnectedCallback() {
      clearTimeout(this.timer);
      this.controller?.abort();
      this.requestId++;
    }
    queueSearch(delay) {
      clearTimeout(this.timer);
      this.controller?.abort();
      const id = ++this.requestId;
      this.products = [];
      this.result.hidden = this.empty.hidden = this.error.hidden = true;
      this.setLoading(false);
      this.status.textContent = '';
      const query = this.input.value.trim();
      if (query.length < 2) return;
      this.timer = setTimeout(() => this.search(query, id), delay);
    }
    setLoading(busy) {
      this.loading.hidden = !busy;
      this.input.setAttribute('aria-busy', String(busy));
    }
    async search(query, id) {
      const controller = new AbortController();
      this.controller = controller;
      let timedOut = false;
      const timeout = setTimeout(() => { timedOut = true; controller.abort(); }, 15000);
      this.setLoading(true);
      this.status.textContent = this.config.loading;
      try {
        const root = this.dataset.root.replace(/\/?$/, '/');
        const url = new URL(root + 'search/suggest.json', location.origin);
        url.search = new URLSearchParams({q: query, 'resources[type]': 'product', 'resources[limit]': '10', 'resources[options][unavailable_products]': 'hide'});
        const response = await fetch(url, {signal: controller.signal});
        if (!response.ok) throw new Error('Search unavailable');
        const data = await response.json();
        if (id !== this.requestId || !this.isConnected) return;
        const rank = new Map(this.config.priority.map((handle, index) => [handle, index]));
        this.products = (data.resources?.results?.products || []).filter(product => product.available !== false).sort((a, b) => (rank.get(a.handle) ?? Infinity) - (rank.get(b.handle) ?? Infinity));
        this.index = 0;
        this.currentQuery = query;
        if (this.products.length) {
          this.showProduct();
          this.result.scrollIntoView({behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'nearest'});
        } else {
          this.empty.hidden = false;
          this.status.textContent = this.empty.textContent;
        }
      } catch (error) {
        if (id !== this.requestId || !this.isConnected) return;
        if (error.name === 'AbortError' && !timedOut) return;
        this.error.hidden = false;
        this.status.textContent = this.error.textContent;
      } finally {
        clearTimeout(timeout);
        if (id === this.requestId) this.setLoading(false);
      }
    }
    trackedUrl(raw, content) {
      const url = new URL(raw, location.origin);
      if (url.origin !== location.origin || !['https:', 'http:'].includes(url.protocol)) return this.dataset.searchUrl;
      const tracking = {utm_source: 'from_the_heart', utm_medium: 'onsite', utm_campaign: 'from_the_heart_page', utm_content: content, utm_term: this.currentQuery};
      Object.entries(tracking).forEach(([key, value]) => url.searchParams.set(key, value));
      return url.pathname + url.search;
    }
    showProduct() {
      const product = this.products[this.index];
      const title = this.querySelector('[data-title]');
      const url = this.trackedUrl(product.url || this.dataset.root + 'products/' + encodeURIComponent(product.handle), 'view_product');
      title.textContent = product.title || '';
      title.href = url;
      this.querySelector('[data-view]').href = url;
      const image = this.querySelector('[data-image]');
      const imageUrl = typeof product.image === 'string' ? product.image : product.featured_image?.url;
      image.hidden = !imageUrl;
      image.alt = product.title || '';
      if (imageUrl) image.src = imageUrl;
      else image.removeAttribute('src');
      const type = this.querySelector('[data-type]');
      type.textContent = product.product_type || product.type || '';
      type.hidden = !type.textContent;
      const price = this.querySelector('[data-price]');
      const amount = Number.parseFloat(product.price);
      price.textContent = Number.isFinite(amount) ? this.formatter.format(amount) : '';
      const allUrl = new URL(this.dataset.searchUrl, location.origin);
      allUrl.search = new URLSearchParams({q: this.currentQuery, type: 'product'});
      this.querySelector('[data-all]').href = this.trackedUrl(allUrl, 'view_all');
      this.result.hidden = false;
      this.empty.hidden = this.error.hidden = true;
      this.status.textContent = this.config.result.replace('[index]', this.index + 1).replace('[count]', this.products.length) + ': ' + product.title;
    }
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
